<template>
  <div class="company_right">
    <div v-if="!id || !allKey.CMTRANS_DETAIL" class="noData no_data_container">
      <span class="img no_data_img"></span>
      <p>Sorry, No data was found or Do not have permission</p>
    </div>

    <div v-else class="company_container">
      <span
        :class="favouriteStatus ? 'isFavorite' : 'isNFavorite'"
        class="favourite_btn"
        @click="setFavouriteStatus"
      ></span>
      <span class="home-btn" @click="setIndexShow"></span>

      <p class="company_common_title">{{ companyName }}</p>
      <div class="contain">
        <div class="deal">
          <title-temp title="Deal overview"></title-temp>
          <div class="deal_info title_info">
            <p v-for="(item, index) of Config.dealData[0]" :key="index" class="info_item">
              <span class="info_title">{{ item.label }}:</span>
              <span class="columnText1" :title="dealData[item.field]">{{ dealData[item.field] }}</span>
            </p>
          </div>
          <table-list :column="Config.dealData[1]" :tableData="dealData.target"></table-list>
          <table-list :column="Config.dealData[2]" :tableData="dealData.acquiror"></table-list>
          <table-list :column="Config.dealData[3]" :tableData="dealData.vendor"></table-list>
          <div class="deal_info regulatory_info">
            <p v-for="(item, index) of Config.dealData[4]" :key="index" class="info_item">
              <span class="info_title">{{ item.label }}:</span>
              <span>{{ dealData[item.field] }}</span>
            </p>
          </div>
        </div>
        <!-- deal dates -->
        <div class="deal_status">
          <title-temp title="Deal structure & dates"></title-temp>
          <table-form :columnData="Config.dealDates" :tableData="datesData" cls="double"></table-form>
        </div>

        <!-- deal values -->
        <div class="deal_values">
          <title-temp title="Deal values"></title-temp>
          <table-form :columnData="Config.dealValues" :tableData="valuesData" cls="double"></table-form>
        </div>

        <!-- pre deal -->
        <div class="pre_deal downContainer">
          <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.CMTRANS_DOWNLOAD"
            @click="downLoadFn(preData, Config.preDealData, Config.preHeaderData, `Pre-deal target financials & multiples`, `unconsolidated statements`)"
          >
            <i class="el-icon-download"></i>
            download
          </el-button>
          <title-temp title="Pre-deal target financials & multiples"></title-temp>
          <div class="pre_table">
            <pre-table
              title="unconsolidated statements"
              :data="preData"
              :column="Config.preDealData"
              :headerColumn="Config.preHeaderData"
            ></pre-table>
          </div>
        </div>

        <!-- post deal -->
        <div class="post_deal downContainer">
          <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.CMTRANS_DOWNLOAD"
            @click="downLoadFn(postData, Config.postDealData, Config.preHeaderData, `Post-deal target financials & multiples`, `Consolidated statements`)"
          >
            <i class="el-icon-download"></i>
            download
          </el-button>
          <title-temp title="Post-deal target financials & multiples"></title-temp>
          <div class="pre_table">
            <pre-table
              title="Consolidated statements"
              :data="postData"
              :column="Config.postDealData"
              :headerColumn="Config.preHeaderData"
            ></pre-table>
          </div>
        </div>

        <!-- future deal -->
        <div class="future_deal downContainer">
          <el-button
            type="text"
            class="downLoadBtn"
            v-if="allKey.CMTRANS_DOWNLOAD"
            @click="downLoadFn(futureData, Config.futureDealData, Config.futureHeaderData, `Future-deal target financials & multiples`, `statements`)"
          >
            <i class="el-icon-download"></i>
            download
          </el-button>
          <title-temp title="Future-deal target financials & multiples"></title-temp>
          <div class="pre_table">
            <pre-table
              title="statements"
              :data="futureData"
              :column="Config.futureDealData"
              :headerColumn="Config.futureHeaderData"
            ></pre-table>
          </div>
        </div>

        <!-- Deal stock prices -->
        <div class="deal_stock_prices">
          <title-temp title="Deal stock prices"></title-temp>
          <table-form
            :columnData="Config.stockPrices"
            :tableData="stockData.office"
            largeLabelCls="doublelargeLabel"
          ></table-form>
          <div class="stock_item">
            <p class="stock_title">
              <span class="title_span">Target name:</span>
              <span>{{ stockData.targetName }}</span>
            </p>
            <table-form
              :columnData="Config.stockTarget"
              :tableData="stockData.target"
              largeLabelCls="doublelargeLabel"
            ></table-form>
          </div>
          <div class="stock_item">
            <p class="stock_title">
              <span class="title_span">Acquiror name:</span>
              <span>{{ stockData.acquirorName }}</span>
            </p>
            <table-form
              :columnData="Config.stockAcquiror"
              :tableData="stockData.acquiror"
              largeLabelCls="doublelargeLabel"
            ></table-form>
          </div>
          <div class="stock_item">
            <p class="stock_title">
              <span class="title_span">Vendor name:</span>
              <span>{{ stockData.vendorName }}</span>
            </p>
            <table-form
              :columnData="Config.stockVendor"
              :tableData="stockData.vendor"
              largeLabelCls="doublelargeLabel"
            ></table-form>
          </div>
        </div>

        <!--  先隐藏-->
        <!-- <div class="deal_comments">
          <title-temp title="Deal comments & rationale"></title-temp>
          <div class="content">
            <div class="item" v-for="(item,index) of Config.dealComments" :key="index">
              <p class="content_title">{{item.label}}</p>
              <p class="content_body">{{commentData[item.field]}}</p>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {
  getZephyrOverview,
  getZephyrStructure,
  getAllmultiples,
  getStockPrice,
  postSaveFavourite,
  getFavouriteStatus,
  delFavouriteData
} from "common/js/http/v2Api";

import transcationData from "conf/data/transcation.js";

import TitleTemp from "common/components/Title";
import TableList from "common/components/table";
import TableForm from "common/components/tableForm";
import PreTable from "./components/PreTable";
import { mapState, mapMutations } from "vuex";

import Config from "conf/Transcation";

export default {
  components: {
    TitleTemp,
    TableList,
    TableForm,
    PreTable
  },

  data() {
    return {
      Config,
      companyName: "",

      // deal
      dealData: {},
      datesData: {},
      valuesData: {},
      preData: {
        date: "",
        month: "",
        rate: "",
        tableData: []
      },

      postData: {
        date: "",
        month: "",
        rate: "",
        tableData: []
      },

      futureData: {
        date: "",
        month: "",
        rate: "",
        tableData: []
      },

      stockData: {
        office: transcationData.Prices,
        targetName: "Daimler AG",
        target: transcationData.target,
        acquirorName: "Morgan Stanley",
        acquiror: transcationData.acquiror,
        vendorName: "Zhejiang Geely Holding Group Co., Ltd",
        vendor: transcationData.vendor
      },
      dealComments: [],
      commentData: {
        a: `On 11/01/19 it was announced that Zhejiang Geely Holding Group Co., Ltd has sold a 5.4 per cent stake in Daimler AG, the Stuttgart, Germany-based automobile manufacturer holding company, which is worth EUR 2.85 billion, decreasing the stake held from 9.7 per cent to 4.3 per cent. Morgan Stanley now holds 5.39 per cent of Daimler, an increase from 0.34 per cent previously. Morgan Stanley is reported to be holding this stake on behalf of its institutional
        clients since 04/01/18. Geely denies having sold any of its stake. No further details were disclosed.`
      },
      //收藏
      favouriteStatus: false,
      favouriteId: null,
      userId: parseInt(this.Cookies.get("imsilkroad_userid"))
      // userId: 1
    };
  },

  created() {
    //
    this.getData();

    this.getFaStat();
  },

  methods: {
    getData() {
      this.getOverview();
      this.getStructure();
      this.getMultipleAllData();
      this.getStock();
    },

    async getOverview() {
      const { result } = await getZephyrOverview(this.id);
      result.target = this.converJsonStringData(result.target);
      result.vendor = this.converJsonStringData(result.vendor);
      result.acquiror = this.converJsonStringData(result.acquiror);

      this.companyName = result.deal_headline;
      // 共用一个接口
      this.dealData = result;
      this.valuesData = result;
    },

    //数据处理的各种各样,json格式 字符串格式  还有不规则格式
    // 是json的 返回obj 数组
    // 字符串格式返回  整理后的 obj数组
    // 不认识的格式返回[]
    converJsonStringData(data) {
      try {
        if (data.includes("{") && data.includes("}")) {
          return JSON.parse(data);
        } else {
          let resultData = [];
          resultData = data.split(",").map(item => {
            let dataReturn = {};
            item.split(";").forEach(objItem => {
              const obj = objItem.split(":");
              dataReturn[obj[0]] = obj[1];
            });
            return dataReturn;
          });
          return resultData;
        }
      } catch (error) {
        return [];
      }
    },

    async getStructure() {
      const { result } = await getZephyrStructure(this.id);
      this.datesData = result;
    },

    async getStock() {
      const { result } = await getStockPrice(this.id);
      // result 包含每个模块的全部字段,就直接填充了
      this.stockData.office = result;
      this.stockData.target = result;
      this.stockData.acquiror = result;
      this.stockData.vendor = result;

      this.stockData.targetName = result.target_name || "";
      this.stockData.acquirorName = result.acquiror_name || "";
      this.stockData.vendorName = result.vendor_name || "";
    },

    async getMultipleAllData() {
      const { result } = await getAllmultiples(this.id);
      this.setPreData(result);
      this.setPostData(result);
      this.setFutureData(result);
    },

    setPreData(result) {
      this.preData.date =
        result.zephyr_pre_deal_target_financials_multiples.pre_deal_target_accounts_date;
      this.preData.month = "12";
      this.preData.rate =
        result.zephyr_pre_deal_target_financials_multiples.pre_deal_target_currency;
      this.preData.tableData = this.converMultipleData(
        result.zephyr_pre_deal_target_financials_multiples,
        Config.Data_PreDeal
      );
    },

    setPostData(result) {
      this.postData.date =
        result.zephyr_post_deal_target_financials_multiples.post_deal_target_accounts_date;
      this.postData.month = "12";
      this.postData.rate =
        result.zephyr_post_deal_target_financials_multiples.post_deal_target_currency;
      this.postData.tableData = this.converMultipleData(
        result.zephyr_post_deal_target_financials_multiples,
        Config.Data_PostDeal
      );
    },

    setFutureData(result) {
      this.futureData.date =
        result.zephyr_future_deal_target_financials_multiples.future_deal_target_accounts_date;
      this.futureData.month = "12";
      this.futureData.rate =
        result.zephyr_future_deal_target_financials_multiples.future_deal_target_currency;
      this.futureData.tableData = this.converMultipleData(
        result.zephyr_future_deal_target_financials_multiples,
        Config.Data_FutureDeal
      );
    },

    converMultipleData(data, dataConfig) {
      let result = {};
      Object.keys(dataConfig).forEach(key => {
        result[key] = [];
        dataConfig[key].forEach(item => {
          result[key].push(data[item] || "");
        });
      });
      return result;
    },

    downLoadFn(data, column, header, fileName, title) {
      let result = "";
      const date = data.date ? data.date + "/" : "";
      let headerArr = [date + "12 months"];
      header.forEach(itemArr => {
        let item = date;
        item += itemArr.join("-");
        headerArr.push(item);
      });

      let dataArray = [];
      dataArray = [title, ...headerArr];

      result = dataArray.join(",") + `\n`; //先遍历得到表头信息
      result += `${"Exchange rate" + "\t"},`;
      result += `${data.rate},`;
      result += "\n";

      column.forEach(item => {
        result += `${item.label + "\t"},`;
        data.tableData[item.field].map(dataItem => {
          result += `${dataItem + "\t"},`;
        });
        result += "\n";
      });

      //encodeURIComponent解决中文乱码
      let uri =
        "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(result);
      //通过创建a标签实现
      var link = document.createElement("a");
      link.href = uri;
      //对下载的文件命名
      link.download = `${fileName}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    //收藏相关
    setFavouriteStatus() {
      //准备收藏
      if (!this.favouriteStatus) {
        // module收藏数据类型 1 企业 2 并购 3 行业 4 指标

        let params = {
          companyId: this.id,
          module: 2,
          params: window.location.href,
          title: "",
          userId: this.userId
        };
        this.$prompt("Please enter a title", "Notice", {
          confirmButtonText: "sure",
          cancelButtonText: "cancle"
        }).then(({ value }) => {
          params.title = value;
          this.saveFavorite(params);
        });
      }
      //取消收藏
      else {
        this.delFavori(this.favouriteId);
      }
    },

    //收藏
    async saveFavorite(params) {
      const { result } = await postSaveFavourite(params);
      // Collection of success
      this.$message({
        message: "Collection of success!",
        type: "success"
      });
      this.favouriteStatus = !this.favouriteStatus;
    },

    //取消收藏
    async delFavori(id) {
      const { result } = await delFavouriteData(id);
      // Cancel Successful
      this.$message({
        message: "Cancel Successful!",
        type: "success"
      });
      this.favouriteStatus = !this.favouriteStatus;
    },

    async getFaStat() {
      //companyid, userid
      const { result } = await getFavouriteStatus(this.id, this.userId);
      //无结果代表未收藏
      if (!result) {
        this.favouriteStatus = false;
      } else {
        this.favouriteId = result.id;
        this.favouriteStatus = true;
      }
    },
    setIndexShow() {
      this.changeIndexShow(true);
    },

    ...mapMutations(["changeIndexShow"])
  },

  computed: {
    id() {
      return this.$route.query.id;
    },
    ...mapState({
      allKey(state) {
        return state.v2Permission.v2CurrentPermission;
      }
    })
  },

  watch: {
    id(newValue) {
      this.getData();
      this.getFaStat();
    }
  }
};
</script>

<style scoped>
.info_item {
  display: inline-block;
  width: 50%;
  font-size: 14px;
  color: #4e5671;
  padding-bottom: 10px;
}
.info_title {
  font-weight: 600;
  margin-right: 10px;
}
.regulatory_info {
  padding-top: 20px;
}
.stock_title {
  font-size: 14px;
  color: #4e5671;
  margin: 20px 0px;
}
.title_span {
  font-weight: 600;
  margin-right: 20px;
}
.content {
  border: 1px solid #f3f4f5;
  padding: 17px;
  height: 600px;
  overflow-y: auto;
  font-size: 14px;
  color: #4e5671;
  line-height: 18px;
}
.content_title {
  font-weight: 600;
}
.content_body {
  margin: 10px 0px 20px 0px;
}
.columnText1 {
  display: inline-block;
  width: calc(100% - 149px);
}
.title_info span {
  vertical-align: middle;
}

.downContainer {
  position: relative;
}
.downLoadBtn {
  position: absolute;
  right: 0px;
  top: 10px;
}
.contain {
  padding: 10px;
}
</style>
